<template>
  <v-dialog v-model="dialog" max-width="450px">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        Change Password
      </span>
    </template>
    <v-form
      v-model="valid"
      ref="form"
      lazy-validation
    >
      <v-card>
        <v-card-title>
          <span class="headline">Change Password Form</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="password.oldPassword"
                  color="#091D3B"
                  :type="'password'"
                  :rules="[v => !!v || 'Old Password is required']"
                  label="Old Password *">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="password.newPassword"
                  color="#091D3B"
                  :type="'password'"
                  :rules="[v => !!v || 'Old Password is required']"
                  label="New Password *">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="password.confirmPassword"
                  color="#091D3B"
                  :type="'password'"
                  label="Confirm Password *"
                  :rules="
                    [
                      v => !!v || 'Old Password is required',
                      v => this.password.newPassword == this.password.confirmPassword || 'Password does not match',
                    ]
                  "
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#091D3B" outline @click="dialog=false">Close</v-btn>
          <v-btn class="button-style-blue" @click="submitChangePasswordForm">Change Password</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: 'change-password',
  props: {
  },
  computed: {
  },
  data () {
    return {
        dialog: false,
        valid: true,
        password: {
          oldPassword: null,
          newPassword: null,
          confirmPassword: null
        }
    }
  },
  methods: {
    ...mapActions(['changePassword', 'updateUser']),
    submitChangePasswordForm() {
      if (this.$refs.form.validate()) {
        this.changePassword({
          old_password: this.password.oldPassword,
          new_password: this.password.newPassword,
          confirm_password: this.password.confirmPassword
        })
          .then(() => {
            this.$toastr('success', 'Password Changed!', '')
            this.$router.push({ name: 'login' })
          })
          .catch((error) => {
            this.$toastr('error', 'Error!', 'error')
          })
      }
    }
  }
}
</script>
